export const getters = {
  quarters: state => state.quarters
};
